import { makeStyles } from '@material-ui/core';



export const paginationStyles = makeStyles((theme) => ({
    paginationContainer: {
        '& .pagination': {
            '&-inner': {
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
            },
            '&-text': {
                paddingLeft: theme.spacing(1),
                paddingRight: theme.spacing(1),
            },
            '&-icon-btn': {
                justifyContent: 'center',
                minWidth: '2.75rem',
                padding: theme.spacing(1, 0.75),
                '& svg': {
                    marginLeft: 0,
                    marginRight: 0,
                },
            },
        },
    },

}));



